import { render, staticRenderFns } from "./StffEdit.vue?vue&type=template&id=af9825fa&scoped=true&"
import script from "./StffEdit.vue?vue&type=script&lang=js&"
export * from "./StffEdit.vue?vue&type=script&lang=js&"
import style0 from "./StffEdit.vue?vue&type=style&index=0&id=af9825fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9825fa",
  null
  
)

export default component.exports